export default __webpack_public_path__ + "static/media/web-errorh264.19caa121.mp4";